
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrdershippingPendrivesDialog extends Serenity.EntityDialog<OrdershippingPendrivesRow, any> {
        protected getFormKey() { return OrdershippingPendrivesForm.formKey; }
        protected getIdProperty() { return OrdershippingPendrivesRow.idProperty; }
        protected getLocalTextPrefix() { return OrdershippingPendrivesRow.localTextPrefix; }
        protected getService() { return OrdershippingPendrivesService.baseUrl; }
        protected getDeletePermission() { return OrdershippingPendrivesRow.deletePermission; }
        protected getInsertPermission() { return OrdershippingPendrivesRow.insertPermission; }
        protected getUpdatePermission() { return OrdershippingPendrivesRow.updatePermission; }

        protected form = new OrdershippingPendrivesForm(this.idPrefix);

    }
}